// extracted by mini-css-extract-plugin
module.exports = {"note-list":"styles_note-list__1bykk","add-note":"styles_add-note__1JvZX","note-list-item":"styles_note-list-item__3nPt8"};